module.exports = __webpack_public_path__ + "static/media/1016971.4a46374f.jpg";